import React, { Component } from 'react';
import CommentsList  from './CommentsList';
import './../Chart.css';
import {Button} from 'reactstrap';
import axios from './../../../axios';
import * as url from './../../../utils/url';
import {canSetGoalsForChart} from './../../../utils/privacySettings';
import { connect } from "react-redux";
import findIndex from 'lodash/findIndex';
import filter from 'lodash/filter';
import find from 'lodash/find';
import autosize from 'autosize';
import SetGoal from './SetGoal';
import { deepClone } from '../../../utils/copyObject';
import { GiArrowScope } from "react-icons/gi"
import { profilePicValidityCheck } from '../../../utils/constants';

class ChartListItemOptions extends Component {
  constructor(props) {
    super(props);
    this.state = {
      commentList : [],
      displayComments : [],
      plotData : [],
      isCommentsShown : false,
      page : 0,
      isSetGoalsShown : false,
      commentCount : this.props.commentCount,
      total : 0,
      goals : this.props.goalData && this.props.goalData.length > 0 ? deepClone(this.props.goalData) : []
    }
  }

  componentDidMount() {
    autosize(this.commentInput);
  }

  handleCommentAdded = ({target}) => {
    const {value} = target;
    this.setState({ selfComment : value });
  }

  handleCommentSubmit = () => {
    const {commentList,selfComment,commentCount} = this.state;
    const {id} = this.props;
    const {profile} = this.props.user;
    if(selfComment === undefined || selfComment.length === 0 ) {
      return;
    }
    axios.post(url.addComment(id),{text:selfComment}).then(({data}) => {
      const payload = data.data;
      commentList.splice(0,0,{...payload,
        userId : {
        _id : payload.userId,
        firstName : profile.firstName,
        lastName : profile.lastName,
        profilePic : profilePicValidityCheck(profile.profilePic) ? profile.profilePic : null}});
        this.setState({commentList : commentList,
          displayComments : Array.from(commentList),
          selfComment:'',isCommentsShown : true,
          commentCount : commentCount + 1});
          this.commentInput.style.height = '40px';
    }).catch((error) => {
      //todo show error
    });
  }

  fetchCommentsForChart = () => {
    const {id} = this.props;
    const {isCommentsShown,page,commentCount} = this.state;
    if(!isCommentsShown) {
      if(commentCount > 0) {
        axios.get(url.getComments(id)).then(({data}) => {
          const allComments = data.data.comments;
          this.setState({commentList : allComments,
            displayComments : allComments.slice(0,2),
            isSetGoalsShown : false,
            isCommentsShown : !isCommentsShown,
            page:0,
            total:allComments.length});
        }).catch((error) => {
          //todo show error
        });
      }
      this.setState({
        isSetGoalsShown : false,
        isCommentsShown : !isCommentsShown,
        });
    } else {
      this.setState({isCommentsShown : !isCommentsShown});
    }
  }

  fetchMoreCommentsForChart = () => {
    const {commentList,page,displayComments} = this.state;
    let comments = [];
    if(page === 0) {
      comments = commentList.slice(0,5);
      this.setState({
        displayComments : comments,
        page : 1
      });
    } else {
      const start = page * 5;
      comments = displayComments.concat(commentList.slice(start,start + 5));
      this.setState({
        displayComments : comments,
        page : page + 1
      });
    }
  }

  handleDeleteComment = (commentId) => {
    const {displayComments,commentCount} = this.state;
    console.log(this.props,'---', displayComments,'--', commentId)
    const {id} = this.props;
    // return
    axios.delete(url.deleteComment(id,commentId)).then(({data}) => {
      console.log('data---', data)
      console.log('displayComments---', displayComments)

      const i = findIndex(displayComments,{_id:commentId});
      console.log(i)
      displayComments.splice(i,1);
      this.setState({displayComments : displayComments,
        commentList : deepClone(displayComments),
        commentCount : commentCount - 1});
    }).catch((error) => {
      //todo show error
    });
  }

  handleSetGoal = () => {
    this.setState((prevState) =>
      ({isSetGoalsShown : !prevState.isSetGoalsShown,isCommentsShown : false}));
  }

  /**
   * Adding and updating goals on chart.
   */
  handleSendGoalToServer = (kpiId,isEdit,activeGoal) => {
    let { goals } = this.state;  
    const chartId = this.props.id;
    // console.log(goals, chartId, kpiId,isEdit, activeGoal)
    
    if(isEdit && activeGoal.kpiId) {
      axios.put(url.updateGoal(chartId,activeGoal._id),activeGoal).then(({data}) => {
        const indexToUpdate = findIndex(goals,{_id : data.data._id});
        goals[indexToUpdate] = activeGoal;
        this.setState({ goals });
        this.props.onGoalSet(chartId,goals);
      });
    } else {

      // Creating POST Object of Goal
      console.log('create goal')
      let goal = { ...activeGoal , name : kpiId.name,kpiId:kpiId.id };
      axios.post(url.setGoal(chartId),goal).then(({data}) => {
        goals.push(data.data);
        this.setState({ goals });
        console.log('here----')
        this.props.onGoalSet(chartId,goals);
      });
    }
  }

  /**
   * Deleting goal from chart using unique goal id.
   */
  handleDeleteGoal = (goal) => {
    const { id } = this.props;
    let { goals } = this.state;
    console.log(goal, id)
      const indexToRemove = findIndex(goals,{name:goal.name});
      axios.delete(url.deleteGoal(id,goal._id)).then(({data}) => {
        goals.splice(indexToRemove,1);
        this.setState({goals});
        console.log(goal, goals, id)
        this.props.onGoalDelete(id,goal)
      });
    
  }

  getGoalsCount = () => {
    const {kpiData} = this.props;
    const {goals} = this.state;
    if(kpiData) {
      const i = filter(kpiData,(kpi) => find(goals,{name : kpi.name}) ? true : false);
      if(i) {
        return i.length === 0 ? 'No' : i.length
      }
      return 0;
    }
    return 0;
  }

  populateSetGoal = (canSetGoals) => {
    const { kpiData } = this.props;
    const { goals } = this.state;

    return kpiData.map((kpi, index) => {
      return(
        <div key={kpi.id+kpi.name} className="col-lg-4 col-md-4 text-center mb10">
          <SetGoal
            key={kpi.name}
            kpi={kpi}
            goalIndex={this.props.id + index}
            goalData={find(goals,{name : kpi.name})}
            onSetGoal={this.handleSendGoalToServer}
            onDeleteGoal={this.handleDeleteGoal}
            checkGoalLength={this.addGoalLength}
            canSetGoals={canSetGoals}
          />
        </div>
      )
    })
  }

  render() {
    
    const {commentList,selfComment,displayComments,goals,isCommentsShown,commentCount,page,isSetGoalsShown} = this.state;
    const {chartOwner,kpiData} = this.props;
    const {profile} = this.props.user;
    let canSetGoals = canSetGoalsForChart(chartOwner,profile,kpiData);
    let hideSeeGoals;
    if(goals) {
      if(goals.length === 0 && !canSetGoals) {
        hideSeeGoals = true;
      } else {
        hideSeeGoals = false;
      }
    } else {
      hideSeeGoals = true;
    }
    return (
      <div style={{paddingLeft:'20px',paddingRight:'20px',paddingBottom:'10px'}}>
        <div className="row" style={{color:'#5099DE'}}>
          <div className="col-lg-6 col-md-6"
            onClick={this.handleSetGoal}>
            {
              goals && goals.length > 0 ?
              <span style={{cursor:'pointer',lineHeight:'22px',color:'#5099DE',letterSpacing: '0.05em'}}>
                {this.getGoalsCount()} Goals Set </span> :
              canSetGoals ?
              <span className="chart-options-goals-btn cursor-pointer" >
                  No Goals Set
              </span> :
              hideSeeGoals = true
            }
            {/* <i style={{marginLeft:'10px',
              color:canSetGoals || goals.length > 0 ? '#5099DE' : '#A5A6AC',
              display:hideSeeGoals ? 'none':'initial'}
            }
              className="flaticon-down-arrow"></i> */}

              <GiArrowScope color="#cbab00" className="mb-1 ml-2 cursor-pointer" size={"19px"} />
          </div>
          <div className="col-lg-6 col-md-6 text-right">
            <span className="comment-count" style={{cursor:'pointer',lineHeight:'22px'}}
              onClick={this.fetchCommentsForChart}>
              {commentCount ? `${commentCount} Comments` : '0 Comments'}
            </span>
          </div>
        </div>
        <hr style={{marginTop:'15px',marginBottom:'10px'}}/>
        <div className="row"
          style={{display : isSetGoalsShown ? 'flex' : 'none'}}>
          {this.populateSetGoal(canSetGoals)}
        </div>
        <div className="row" style={{display: isSetGoalsShown ? 'none' : 'block'}}>
          <div className="col-lg-12 col-md-12 comments-container">
            <span className="comments-char-count">
              {selfComment ? selfComment.length : 0}/150
            </span>
            <textarea
              name="̵comment"
              id="input-comment"
              maxLength="150"
              rows={1}
              style={{color:'#54555A'}}
              onChange={this.handleCommentAdded}
              placeholder="Write a comment..."
              value={selfComment}
              ref={c => (this.commentInput = c)}
            />
            <Button className="send-comment-button" onClick={this.handleCommentSubmit}>
                <i className="send-icon flaticon-send"></i>
            </Button>
          </div>
        </div>
        <div style={{display:isCommentsShown ? 'block':'none'}}>
          <CommentsList
            comments={displayComments}
            onDeleteComment={this.handleDeleteComment}
            onSeeMoreComments={this.fetchMoreCommentsForChart}
            totalComments={commentList.length}
            currentUser={this.props.user.profile}
            chartOwner={chartOwner}
          />
        </div>
      </div>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    user : state.user
  }
}

export default connect(mapStateToProps)(ChartListItemOptions);
